/* BeyondADS cart drawer extras - free-delivery bar (LB) + "Complete your carbon set" upsell.
   The Dawn drawer re-renders its whole inner HTML on every cart change, so everything here is
   insert-if-missing + compare-before-write, driven by the real /cart.js. */
(function () {
  var dataEl = document.getElementById('bd-cart-data');
  if (!dataEl) return;
  var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var POOL = (D.items || []).filter(function (it) { return it.variants && it.variants.length; });
  var cart = null;

  function money(cents) {
    var whole = cents % 100 === 0, amount = (cents / 100).toFixed(2), noDec = String(Math.round(cents / 100));
    return String(D.money || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, whole ? noDec : amount)
      .replace(/<[^>]*>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var TRUCK = '<svg class="bdcx-bar__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2z"/><path d="M13 9h4.5L21 12.5V16h-8"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
  var CHECK = '<svg class="bdcx-bar__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9.5"/><path d="M7.5 12.5l3 3 6-6.5"/></svg>';

  /* ---------- free-delivery bar ---------- */
  function barState() {
    var total = cart ? cart.total_price : 0, left = Math.max(0, D.threshold - total), done = left === 0;
    return {
      done: done, pct: Math.min(1, total / D.threshold),
      msg: done ? 'Free delivery unlocked, you save <b>' + money(D.rate) + '</b>' : 'You are only <b>' + money(left) + '</b> away from free delivery'
    };
  }
  function paintBar(el) {
    var s = barState();
    if (el.getAttribute('data-k') === s.msg) return; // compare before write
    el.setAttribute('data-k', s.msg);
    el.classList.toggle('is-done', s.done);
    el.querySelector('[data-ico]').innerHTML = s.done ? CHECK : TRUCK;
    el.querySelector('[data-msg]').innerHTML = s.msg;
    el.style.setProperty('--bdcx', s.pct.toFixed(4));
  }
  function barHtml() {
    return '<div class="bdcx-bar bdcx-bar--items" data-bdcx-bar aria-live="polite"><div class="bdcx-bar__row"><span data-ico></span>' +
      '<span class="bdcx-bar__msg" data-msg></span><span class="bdcx-bar__goal">' + money(D.threshold) + '</span></div>' +
      '<div class="bdcx-bar__track"><div class="bdcx-bar__fill"></div></div></div>';
  }

  /* ---------- upsell ---------- */
  function picks() {
    var inCart = {};
    ((cart && cart.items) || []).forEach(function (li) { inCart[li.product_id] = 1; });
    return POOL.filter(function (it) { return !inCart[it.pid]; }).slice(0, 2);
  }
  function upHtml(list, where) {
    var h = '<div class="bdcx-up bdcx-up--' + where + '" data-bdcx-up data-k="' + list.map(function (i) { return i.pid; }).join(',') + '">' +
      '<div class="bdcx-up__head"><h3 class="bdcx-up__title">Complete your carbon set</h3><span class="bdcx-up__sub">Pairs perfectly</span></div>';
    list.forEach(function (it) {
      var sel = (!it.many && it.variants.length > 1)
        ? '<select class="bdcx-item__sel" data-bdcx-sel="' + it.pid + '" aria-label="Choose an option for ' + esc(it.title) + '">' +
          it.variants.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>'
        : '';
      var btn = it.many
        ? '<a class="bdcx-item__add" href="' + esc(it.url) + '">Choose</a>'
        : '<button type="button" class="bdcx-item__add" data-bdcx-add="' + it.pid + '">+ Add</button>';
      h += '<div class="bdcx-item" data-pid="' + it.pid + '"><a class="bdcx-item__img" href="' + esc(it.url) + '"><img src="' + esc(it.img) + '" alt="' + esc(it.title) + '" width="56" height="56" loading="lazy"></a>' +
        '<div class="bdcx-item__body"><a class="bdcx-item__name" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
        '<span class="bdcx-item__price" data-bdcx-price="' + it.pid + '"></span>' + sel +
        '<span class="bdcx-item__chip" data-bdcx-chip="' + it.pid + '" hidden>Unlocks free delivery</span></div>' + btn + '</div>';
    });
    return h + '</div>';
  }
  function item(pid) { for (var i = 0; i < POOL.length; i++) if (String(POOL[i].pid) === String(pid)) return POOL[i]; }
  function variantFor(root, it) {
    var s = root.querySelector('[data-bdcx-sel="' + it.pid + '"]');
    if (!s) return it.variants[0];
    for (var k = 0; k < it.variants.length; k++) if (String(it.variants[k].id) === s.value) return it.variants[k];
    return it.variants[0];
  }
  function paintUp(root) {
    var total = cart ? cart.total_price : 0;
    root.querySelectorAll('[data-pid]').forEach(function (row) {
      var it = item(row.getAttribute('data-pid')); if (!it) return;
      var v = variantFor(row, it), p = row.querySelector('[data-bdcx-price]');
      var t = (it.many ? 'From ' : '') + money(v.price) + (v.compare > v.price ? '<s>' + money(v.compare) + '</s>' : '');
      if (p.innerHTML !== t) p.innerHTML = t;
      var chip = row.querySelector('[data-bdcx-chip]');
      var show = !!(D.threshold && total < D.threshold && total + v.price >= D.threshold);
      if (chip.hidden === show) chip.hidden = !show;
    });
  }

  /* ---------- mount into every drawer render ---------- */
  function render() {
    var list = picks(), key = list.map(function (i) { return i.pid; }).join(',');
    document.querySelectorAll('cart-drawer').forEach(function (d) {
      var hasItems = cart && cart.item_count > 0;
      // bar: under the header (and under the spin-reward strip when one is running)
      var bar = d.querySelector('[data-bdcx-bar]');
      if (D.threshold && hasItems) {
        if (!bar) {
          var anchor = d.querySelector('.bdsw-dt--items') || d.querySelector('.drawer__header');
          if (anchor) { anchor.insertAdjacentHTML('afterend', barHtml()); bar = d.querySelector('[data-bdcx-bar]'); }
        }
        if (bar) paintBar(bar);
      } else if (bar) bar.remove();
      // upsell: after the line items (scrolls with them) and inside the empty-cart message
      [['items', d.querySelector('cart-drawer-items')], ['empty', d.querySelector('.cart-drawer__empty-content') || d.querySelector('.drawer__inner-empty')]].forEach(function (pair) {
        var where = pair[0], host = pair[1];
        var up = d.querySelector('.bdcx-up--' + where);
        if (!host || !list.length) { if (up) up.remove(); return; }
        if (up && up.getAttribute('data-k') !== key) { up.remove(); up = null; }
        if (!up) {
          if (where === 'items') host.insertAdjacentHTML('beforeend', upHtml(list, where));
          else host.insertAdjacentHTML('afterend', upHtml(list, where));
          up = d.querySelector('.bdcx-up--' + where);
        }
        if (up) paintUp(up);
      });
    });
  }

  var busy = false, again = false;
  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; render(); })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; refresh(); } });
  }

  /* ---------- add from the drawer ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-bdcx-sel]')) paintUp(e.target.closest('[data-bdcx-up]'));
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bdcx-add]');
    if (!b || b.disabled) return;
    var it = item(b.getAttribute('data-bdcx-add')); if (!it) return;
    var v = variantFor(b.closest('[data-pid]'), it);
    b.disabled = true; b.textContent = 'Adding…';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: v.id, quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = location.pathname; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'Could not add');
        if (drawer && drawer.renderContents && res.sections) {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        }
        if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bdcx-upsell', cartData: res });
      })
      .catch(function () { b.disabled = false; b.textContent = '+ Add'; })
      .then(function () { setTimeout(refresh, 80); });
  });

  /* ---------- keep in sync: drawer re-renders + any cart write anywhere ---------- */
  if (window.MutationObserver) {
    var q = false;
    var mo = new MutationObserver(function () {
      if (q) return; q = true;
      setTimeout(function () {
        q = false;
        var d = document.querySelector('cart-drawer');
        var missing = d && ((cart && cart.item_count > 0 && D.threshold && !d.querySelector('[data-bdcx-bar]')) || (picks().length && !d.querySelector('[data-bdcx-up]')));
        if (missing) refresh(); // the theme replaced the drawer content: re-read the cart and put ours back
      }, 40);
    });
    document.querySelectorAll('cart-drawer').forEach(function (d) { mo.observe(d, { childList: true, subtree: true }); });
  }
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/;
  var of = window.fetch;
  if (of && !window.__bdcxWrapped) {
    window.__bdcxWrapped = true;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (CART_RE.test(url)) p.then(function () { setTimeout(refresh, 120); }, function () {});
      return p;
    };
  }
  if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 120); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  refresh();
})();
